import React from "react";
import { I18n } from "@aws-amplify/core";
import { get, map, filter, sortBy, size } from "lodash";

import { fetchGet } from "../../api/fetch";

import { Map, Marker, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";

import Grid from "@material-ui/core/Grid";

import FormSection from "../Common/FormSection";

import { getAttributeValue } from "../../utils/profile";

import { levels } from "../../constants/companies";
import { getLov } from "../../utils/lov";

// Fix issue to import marker icon
import L from "leaflet";
import InfoSection from "../Common/InfoSection";
import { Box } from "@material-ui/core";
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

const CreateForm = (props) => {
  const {
    values,
    handleChange,
    level,
    edition,
    typeAttr,
    valid,
    language,
    item,
    colors,
    subZone,
    parentZones,
  } = props;

  const [edgeDevices, setEdgedDevices] = React.useState();
  const [types2, setTypes] = React.useState();


  React.useEffect(() => {
    if (level === levels.device) {
      fetchSiteEdgeDevices();
    }
    const fetchType = async ()=> {
      const types2 = await getLov(
        level === levels.company
          ? "companyTypes"
          : level === levels.site
          ? "siteTypes"
          : level === levels.zone
          ? "zoneTypes"
          : "deviceTypes"
      );
      setTypes(types2)
    }
    fetchType()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchSiteEdgeDevices = async () => {
    try {
      // TODO restrict to sites devices, no API atm
      let devices = await fetchGet("devices?type_id=1&active=true");
      setEdgedDevices(devices);
    } catch (e) {
      console.log(e);
    }
  };

  const primaryAttr = sortBy(
    filter(typeAttr, (attr) => attr.active && attr.app_display_main_page),
    (attr) => get(attr, ["app_display_seq_numb"])
  );

  const secondaryAttr = sortBy(
    filter(typeAttr, (attr) => attr.active && !attr.app_display_main_page),
    (attr) => get(attr, ["app_display_seq_numb"])
  );

  return (
    <Grid container wrap="nowrap" style={{ marginTop: "24px" }}>
      <Grid
        item
        xs={size(secondaryAttr) > 0 ? 6 : 12}
        style={{ paddingRight: size(secondaryAttr) > 0 ? "24px" : "" }}
      >
        <Grid container direction="column">
          {!edition && !subZone && level !== levels.company && (
            <Grid item style={{ marginBottom: "10px" }}>
              <span className="text-87 bold-500" style={{ marginRight: "5px" }}>
                {level === levels.site
                  ? I18n.get("site_company")
                  : level === levels.zone
                  ? I18n.get("companies_site")
                  : level === levels.device
                  ? I18n.get("companies_zone")
                  : ""}
                :
              </span>
              <span className="text-54">{get(item, ["name"])}</span>
            </Grid>
          )}
          <FormSection
            title="name"
            id="name"
            formValue={[get(values, ["name"])]}
            setFormValue={handleChange}
            options={{
              required: true,
              redBorder: !get(valid, ["name"]),
              autocomplete: "off",
            }}
          />
          <FormSection
            title2={I18n.get(`companies_${level}Type`)}
            id={`${level}_type_id`}
            formValue={[get(values, [`${level}_type_id`])]}
            setFormValue={handleChange}
            type="select"
            options={{
              disabled: props.edition,
              required: true,
              redBorder: !get(valid, [`${level}_type_id`]),
              options: map(types2, (type) => ({
                id: get(type, ["id"]),
                name: get(type, [`name_${language}`]),
              })),
            }}
          />
          {level === levels.device && (
            <FormSection
              title2={I18n.get("companies_parentEdgeDevice")}
              id="parent_device_id"
              formValue={[get(values, ["parent_device_id"])]}
              setFormValue={handleChange}
              type="select"
              options={{
                disabled: get(values, [`${level}_type_id`]) === 1,
                options: map(edgeDevices, (d) => ({
                  id: get(d, ["id"]),
                  name: get(d, ["name"]),
                })),
              }}
            />
          )}
          {values["zone_type_id"] && values["zone_type_id"] !== 30 && level === levels.zone && (
            <>
              {subZone ? (
                <Box
                  style={{
                    marginBottom: "10px",
                    marginTop: "-8px",
                    marginLeft: "-8px",
                  }}
                >
                  <InfoSection
                    title2={I18n.get("site_parentZone")}
                    values={[get(item, ["name"])]}
                  />
                </Box>
              ) : (
                <FormSection
                  title2={I18n.get("site_parentZone")}
                  id={"parent_zone_id"}
                  formValue={[get(values, ["parent_zone_id"])]}
                  setFormValue={handleChange}
                  type="select"
                  options={{
                    options: map(
                      filter(
                        parentZones,
                        (z) =>
                          z.parent_zone_id === null &&
                          z.id !== get(item, ["id"])
                      ),
                      (z) => ({
                        id: get(z, ["id"]),
                        name: get(z, ["name"]),
                      })
                    ),
                  }}
                />
              )}
              <FormSection
                title2={I18n.get("site_zoneColor")}
                id={"sys_color_id"}
                formValue={[get(values, ["sys_color_id"])]}
                setFormValue={handleChange}
                type="select"
                options={{
                  color: true,
                  options: map(colors, (c) => ({
                    id: get(c, ["id"]),
                    name: get(c, ["rgb"]),
                  })),
                }}
                style={{ maxWidth: "150px" }}
              />
            </>
          )}
          {map(primaryAttr, (attr) => (
            <FormSection
              key={attr.id}
              attribute={attr}
              id={attr.id}
              formValue={[getAttributeValue(values, attr.id)]}
              setFormValue={handleChange}
            />
          ))}
        </Grid>
      </Grid>
      {size(secondaryAttr) > 0 && (
        <Grid item xs={6} style={{ paddingLeft: "24px" }}>
          <Grid container direction="column">
            {map(secondaryAttr, (attr) => (
              <FormSection
                key={attr.id}
                attribute={attr}
                id={attr.id}
                formValue={[getAttributeValue(values, attr.id)]}
                setFormValue={handleChange}
              />
            ))}
            {level === levels.site && typeAttr && (
              <Grid item>
                <Map
                  style={{ height: "300px", width: "100%", zIndex: 1 }}
                  zoom={15}
                  center={[
                    getAttributeValue(values, 28) || 45.2,
                    getAttributeValue(values, 92) || -72.2,
                  ]}
                >
                  <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                  {getAttributeValue(values, 28) &&
                    getAttributeValue(values, 92) && (
                      <Marker
                        position={[
                          getAttributeValue(values, 28),
                          getAttributeValue(values, 92),
                        ]}
                      />
                    )}
                </Map>
              </Grid>
            )}
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default CreateForm;
